import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class AppInsightsService {
  private appInsights: ApplicationInsights;
  private initialized = false;

  constructor(private http: HttpClient) {
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: '',
        enableAutoRouteTracking: true,
        endpointUrl: 'https://dc.applicationinsights.azure.us/v2/track',
        enableDebug: true,
        loggingLevelConsole: 2,
        loggingLevelTelemetry: 2,
        enableCorsCorrelation: true,
        correlationHeaderExcludedDomains: ['*.azure.us'],
        disableFetchTracking: false,
        enableRequestHeaderTracking: true,
        enableResponseHeaderTracking: true,
      },
    });

    this.initializeAppInsights();
  }

  private async initializeAppInsights() {
    try {
      const response = await this.http.get<{ instrumentationKey: string }>('/appinsights/config').toPromise();
      
      if (response && response.instrumentationKey) {
        this.appInsights.config.instrumentationKey = response.instrumentationKey;
        this.appInsights.loadAppInsights();
        this.initialized = true;
        console.log('App Insights initialized successfully');
      } else {
        console.error('No instrumentation key received from backend');
      }
    } catch (error) {
      console.error('Failed to initialize App Insights:', error);
    }
  }

  // Log trace messages
  logTrace(message: string, properties?: { [key: string]: any }) {
    try {
      if (!this.initialized) {
        console.warn('App Insights not initialized, trace not sent:', message);
        return;
      }

      this.appInsights.trackTrace({ message }, properties);
      this.appInsights.flush();
    } catch (error) {
      console.error('Error sending trace:', error);
    }
  }
}
